import React from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import MeasurementDetailsList from './MeasurementDetailsList';
import {Icons} from '../../../utils/Icons';

const MeasurementDetails = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: Icons.house },
		{ to: '#', label: 'Medio Ambiente', icon: Icons.environment },
		{ to: '/water-rights/list', label: 'Derechos de Agua', icon: Icons.water },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Detalle de Mediciones'
						links={breadcrumbLinks}
						icon={Icons.gauge}
					/>
					<Row>
						<Col md={12}>
							<Card>
								<CardBody>
									<MeasurementDetailsList />
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default MeasurementDetails;
